import { getConfigValue } from './OhsConfigServices';
import { setPermissions } from './OhsConfigurations';
import { OhsModulePermissions } from './OhsModulePermissions';
export class OhsVdocPermissions {
  view: boolean;
  view_copyable: boolean;
  create: boolean;
  edit: boolean;
  up_version: boolean;
  allocate: boolean;
  copy: boolean;
  signoff: boolean;
  archive: boolean;
  delete: boolean;

  constructor(flag: boolean) {
    this.view = flag;
    this.create = flag;
    this.edit = flag;
    this.signoff = flag;
    this.archive = flag;
    this.delete = flag;
    this.view_copyable = flag;
    this.up_version = flag;
    this.allocate = flag;
    this.copy = flag;
  }
}
export class OhsVdocConfig {
  TITLE: string;
  PERMISSIONS: OhsVdocPermissions;
  MORPH_PERMISSIONS: OhsModulePermissions;
  constructor(config: any) {
    this.TITLE = getConfigValue(config, 'TITLE');
    this.PERMISSIONS = new OhsVdocPermissions(false);
    this.MORPH_PERMISSIONS = new OhsModulePermissions(false);
    setPermissions(this.PERMISSIONS, getConfigValue(config, 'PERMISSIONS'));
    setPermissions(
      this.MORPH_PERMISSIONS,
      getConfigValue(config, 'MORPH_PERMISSIONS')
    );
  }
}
